import React from 'react'
import Asset from './BaseAssets'

const Glow = (props) => {
  return (
    <Asset.Img
      {...props}
      projection={props.projection}
      scale={1}
      x={props.x}
      y={props.y}
    />
  )
}

export default Glow
